import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  guideVideos: null,
  guideVideosForAfterSchool: null,
  score: null,
  levelTestList: null,
  singleTestResult: null,
  testFiles: null,
  test: null,
  guidePPT: null,
  loaded: false,
};

const jsonDataSlice = createSlice({
  name: 'jsonData',
  initialState,
  reducers: {
    setJsonData: (state, action) => {
      Object.assign(state, action.payload, { loaded: true });
    },
  },
});

export const { setJsonData } = jsonDataSlice.actions;
export default jsonDataSlice.reducer;
export const selectJsonData = (state) => state.jsonData;
